import {Command} from './Command';

export default class GetTypeFuelsCommand extends Command {
    name = 'list/type_fuels';

    usesLanguage = true;

    // public handle($arguments: any): Promise<SomeCheckFormDataResponse> {
    public handle($arguments: any): Promise<any[]> {
        console.log('GetTypeFuelsCommand->handle');

        // return this.apiResponse<SomeCheckFormDataResponse>('get', this.name, $arguments, SomeCheckFormDataResponse);
        return this.apiResponse('get', this.name, $arguments);
    }

    protected fake(method: string, $arguments: any): Promise<any> {
      return Promise.resolve({
        success: true,
        data: [
        ]
      });

      return Promise.reject({
          success: false,
          error: {
              code: 'nG12',
              note: 'Слишком много ошибок',
              fields: {
                  height: 'Высота паллеты не может быть менее 50 см',
                  townSender: 'Мы сюда не возим, это ж, блин, Рио-Де-Жанейро!!',
                  tarif: 'Неправильно выбран тариф',
                  weight: 'Нельзя по украинским дорогам возить груз свыше 202 тонн'
              }
          }
      });
    }
}
